const baseURL = 'https://peruenvidrio.com/';

export default baseURL;
